import { io } from "socket.io-client";

// const URL = "http://localhost:5000";
export const URL = process.env.REACT_APP_BACKEND_URL || "https://meetbackend.nsashimenon.com"
export const WebUrl = "http://localhost:3000";

// const URL = "https://video-call-server-gm7i.onrender.com";

export const socket = io(URL);
export const navbarBrand = "RSIS Meeting";
